/** Symptoms-lens preview opt-in. Reveals the gated Symptoms tab (and admits the
 *  `/symptoms` routes) for one visitor via a `?symptoms-preview=<SYMPTOMS_PREVIEW_TOKEN>`
 *  magic link, WITHOUT flipping the global `SYMPTOMS_ENABLED` build switch.
 *  Mirrors lib/ai-preview.ts. The httpOnly token cookie (`symptoms-preview`) is
 *  read edge-side by the proxy preview-gate for route access; this JS-readable
 *  companion (`symptoms-preview-active`) is what the explorer reads client-side
 *  to reveal the tab — deliberately NOT a server `cookies()` read, which threw
 *  DYNAMIC_SERVER_USAGE on the statically-generated shells (see git 648b1fca). */
export const SYMPTOMS_PREVIEW_TOKEN_COOKIE = "symptoms-preview"
export const SYMPTOMS_PREVIEW_ACTIVE_COOKIE = "symptoms-preview-active"
export const SYMPTOMS_PREVIEW_PARAM = "symptoms-preview"

/** True when the visitor opted into the Symptoms-lens preview. Client-only —
 *  reads `document.cookie`, returns false during SSR so it never forces a page
 *  dynamic. */
export function hasSymptomsPreviewActive(): boolean {
  if (typeof document === "undefined") return false
  return document.cookie
    .split("; ")
    .includes(`${SYMPTOMS_PREVIEW_ACTIVE_COOKIE}=1`)
}
